import { useState, useRef, useEffect } from "react";

export default function ProdunitModular() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => { 
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-style">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <h4>Detailing & Precision</h4>
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        {/* <span>Design</span> */}
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <h4 className="heading">Blending Craft, Technology, and Design</h4>
                </div>

                <div className="col-lg-6 col-md-6">
                    <p>At Saysha, every modular creation is a balance of craftsmanship and innovation. Our designs merge artisanal detailing with advanced technology to achieve precision and beauty in every form. From concept to completion, each furniture piece is thoughtfully engineered for function and aesthetics. The result modular spaces that are seamless, enduring, and distinctly Saysha.</p>
                </div>

            </div>
        </div>
    </section>             
    </>
  )
}
